// extracted by mini-css-extract-plugin
export default {"root":"Z69rAhtMA_SUUN1w1ktT"};